// Pickfood mark: yellow location-pin (reads as the "P") with a fork inside a cream circle. Tintable for white-label.
export function PickfoodMark({ size = 32, color = "var(--brand)", className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
      <path d="M32 3C18.2 3 8 13.4 8 27c0 9.7 5.6 17.4 12.9 24.9 3.1 3.2 6 6 7.9 8.6 1.6 2.1 4.8 2.1 6.4 0 1.9-2.6 4.8-5.4 7.9-8.6C50.4 44.4 56 36.7 56 27 56 13.4 45.8 3 32 3Z" fill={color} />
      <circle cx="32" cy="26" r="13.5" fill="#FDFBF7" />
      <g fill={color}>
        <rect x="26.4" y="16.5" width="2" height="8.5" rx="1" />
        <rect x="31" y="16.5" width="2" height="8.5" rx="1" />
        <rect x="35.6" y="16.5" width="2" height="8.5" rx="1" />
        <rect x="26.4" y="23.4" width="11.2" height="2.2" rx="1.1" />
        <rect x="30.6" y="24.5" width="2.8" height="12.5" rx="1.4" />
      </g>
    </svg>
  );
}

export function BrandLogo({ name = "Pickfood", logoUrl = null, color = "var(--brand)", size = 34, showName = true, className = "" }) {
  // Platform brand: use the official Pickfood wordmark image (kept on a white chip for legibility on any background)
  if (name === "Pickfood" && !logoUrl) {
    return (
      <span className={`inline-flex items-center bg-white rounded-lg px-2 py-1 ${className}`} data-testid="pickfood-logo">
        <img src="/pickfood-logo.webp" alt="Pickfood" style={{ height: size }} className="w-auto object-contain" />
      </span>
    );
  }
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      {logoUrl ? (
        <img src={logoUrl} alt={name} style={{ height: size, width: size, objectFit: "cover" }} className="rounded-xl" />
      ) : (
        <PickfoodMark size={size} color={color} />
      )}
      {showName && (
        <span className="font-head font-extrabold tracking-tight leading-none" style={{ fontSize: size * 0.62, marginLeft: -size * 0.06 }}>
          {name}
        </span>
      )}
    </div>
  );
}
